import config from "@src/config";
import type { PostHogConfig } from "posthog-js";
import { PostHogProvider } from "posthog-js/react";

interface PostHogEnvironmentProviderProps {
	children: React.ReactNode;
}

export function PostHogEnvironmentProvider({
	children,
}: PostHogEnvironmentProviderProps) {
	if (!config.posthog.key || !config.posthog.host) {
		return <>{children}</>;
	}

	const isDesktop =
		typeof window !== "undefined" && Boolean(window.electronAPI?.isElectron);
	const clientType = isDesktop ? "desktop" : "webapp";

	const options: Partial<PostHogConfig> = {
		api_host: config.posthog.host,
		ui_host: "https://us.posthog.com",
		autocapture: false,
		persistence: isDesktop ? "localStorage" : "localStorage+cookie",
		loaded: (posthog) => {
			posthog.register({
				client: clientType,
				...(config.sentry.environment && {
					environment: config.sentry.environment,
				}),
				...(config.appVersion && { app_version: config.appVersion }),
			});
		},
	};

	return (
		<PostHogProvider apiKey={config.posthog.key} options={options}>
			{children}
		</PostHogProvider>
	);
}
